import Link from "next/link";
import { VFC } from "react";

import { useDraft } from "hooks/users/useDraft";

import { CurrentUser } from "lib/type";

import { FiClock } from "react-icons/fi";
import { FaRegEdit } from "react-icons/fa";

type DraftArticlesProps = {
  isAuthChecking: boolean;
  user: CurrentUser;
  author: CurrentUser;
};

const DraftArticles: VFC<DraftArticlesProps> = ({
  isAuthChecking,
  user,
  author,
}) => {
  const { drafts } = useDraft(isAuthChecking, user, author);

  const draftArticles = drafts
    ?.map((article) => {
      if (!article) return;
      const { articleID, thumb, title, color, createdAt } = article;
      return (
        <li
          key={article.articleID}
          className="shadow-light-700 dark:shadow-dark-400 border-l-[0.5rem] border-solid shadow-lg"
          style={{ borderColor: color }}
        >
          <div className="overflow-hidden">
            <Link href={`/articles/${articleID}/edit`}>
              <a className="relative block p-4">
                <p className="absolute right-0 top-1/2 -translate-y-1/2 rotate-12 transform text-6xl opacity-20">
                  {thumb}
                </p>
                <h3 className="mb-2 text-xl">{title}</h3>
                <p className="flex items-center">
                  <FiClock className="mr-1" />
                  {createdAt}
                </p>
              </a>
            </Link>
          </div>
        </li>
      );
    })
    .filter((draft) => draft);

  return (
    <>
      {drafts && drafts.length > 0 && (
        <section className="container py-4 lg:px-0">
          <h2 className="mb-4 flex items-center text-xl">
            <FaRegEdit className="mr-1" />
            下書き状態の投稿
          </h2>
          <ul className="space-y-2 md:grid md:grid-cols-2 md:gap-4 md:space-y-0">
            {draftArticles}
          </ul>
        </section>
      )}
    </>
  );
};

export default DraftArticles;
